export function validate(inputID: string, errorCode: string |any) {
    const input: HTMLInputElement = document.getElementById(inputID) as HTMLInputElement;

    if (errorCode === "auth/invalid-email" || errorCode === "auth/user-not-found" || errorCode === "auth/wrong-password") {
        input.setCustomValidity("Invalid Credentials");
    }

    input.reportValidity();
}